<template>
    <custom-modal>
        <template v-slot:maincontent>
            <div class="p-4 bg-[#23242A] text-[14px] rounded-lg">
                <div class="relative">
                    <div class="flex flex-row justify-between items-center h-[50px]">
                        <h2 class="justify-center text-white text-xl font-bold font-['Roboto'] leading-6 tracking-tight">Add Product to Audit</h2>
                    </div>
                    <span v-if="addedProductList.length==0" @click.prevent="closeClick()" class="absolute right-1 top-1 pointer cursor-pointer hover:opacity-60">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19.3333 2.54602L17.4533 0.666016L10 8.11935L2.54667 0.666016L0.666672 2.54602L8.12001 9.99935L0.666672 17.4527L2.54667 19.3327L10 11.8793L17.4533 19.3327L19.3333 17.4527L11.88 9.99935L19.3333 2.54602Z" fill="white"/>
                        </svg>
                    </span>
                    <div v-else class="absolute right-1 top-0 flex flex-row gap-2">
                        <button @click.prevent="confirmClose()" class="h-11 px-4 py-2 bg-white rounded-md inline-flex justify-center items-center gap-2 overflow-hidden">
                            <div class="justify-center text-green-500 text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest">Cancel</div>
                        </button>
                        <button @click.prevent="addProducts" class="h-11 px-4 py-2 bg-green-500 rounded-md inline-flex justify-center items-center gap-2 overflow-hidden">
                            <div class="justify-center text-white text-sm font-medium font-['Roboto'] uppercase leading-4 tracking-widest">Add</div>
                        </button>
                    </div>
                </div>
                <div class="flex flex-row items-center mb-6 mt-0" tabindex="0">
                    <!-- @blur="closeDropdown" -->
                    <div class="flex flex-grow relative mt-4">
                        <div class="flex justify-between  w-full rounded-md  relative border border-2 border-white border-neutral-600">
                            <svg  class="absolute z-[99] left-[16px] top-[17px]" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 15L10.3333 10.3333M11.8889 6.44444C11.8889 9.45133 9.45133 11.8889 6.44444 11.8889C3.43756 11.8889 1 9.45133 1 6.44444C1 3.43756 3.43756 1 6.44444 1C9.45133 1 11.8889 3.43756 11.8889 6.44444Z" stroke="white" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
                            </svg>
                            <input :disabled="disabled" @focus="openDropDown" v-model="search" type="text" class="rounded w-full relative pl-10 h-[50px] bg-transparent align-top border-[#464851] border-2 placeholer-neutral-400 focus:border-transparent focus:ring-0 focus:outline-none" placeholder="Search by Product Name, SKU, GTIN">
                            <!-- @blur="closeDropdown" -->
                            <svg v-if="open" @click="resetSearch" class="cursor-pointer absolute right-[10px] top-[17px]" width="16" height="16" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.25 1.8075L10.1925 0.75L6 4.9425L1.8075 0.75L0.75 1.8075L4.9425 6L0.75 10.1925L1.8075 11.25L6 7.0575L10.1925 11.25L11.25 10.1925L7.0575 6L11.25 1.8075Z" fill="white"/>
                            </svg>
                        </div>
                        <div v-if="open" class="w-full flex flex-col flex-grow z-[99] absolute top-[50px]" :class="classString">
                            <div class="min-h-[100px] max-h-[380px] overflow-auto bg-light-black pb-[10px] shadow-2xl">
                                <table class="table-auto w-full h-full">
                                    <thead>
                                        <tr class="border-b border-gray-black">
                                            <th class="p-4 text-left">Name</th>
                                            <th class="p-4 text-left">Variant</th>
                                            <th class="p-4 text-left w-[150px]">Category</th>
                                            <th class="p-4 text-left w-[150px]">Brand</th>
                                            <th class="p-4 text-left">SKU</th>
                                            <th class="p-4 text-left">GTIN</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="results.length>0">
                                        <tr v-for="(row, index) in results" :key="index" @click="select(row)" class="row h-30 transition duration-500 bg-light-black hover:bg-theme-green/20 cursor-pointer" >
                                            <td class="p-4 flex flex-row items-center gap-2"><img v-if="row.image" class="w-6 h-6 rounded" :src="row.image" /><span class="text-theme-green">{{ row.name }}</span></td>
                                            <td class="p-4">{{ row.variantName }}</td>
                                            <td class="p-4">{{ row.category?.name }}</td>
                                            <td class="p-4">{{ row.brand?.name }}</td>
                                            <td class="p-4">{{ row.sku }}</td>
                                            <td class="p-4">{{ row.barcode }}</td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td class="text-center" :colspan="6">
                                                <div class="flex flex-col gap-5 py-5">
                                                    <div class="italic text-theme-modalbg">No product found</div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <LotSelectPop v-if="lotSelectPopup" :payload="payload" :product="selectedProduct" @change="lots => selectedLots=lots" @close="lotSelectPopup=false" @add="addProduct" />
                </div>
                <div class="flex flex-col h-[360px] gap-1 overflow-y-auto">
                    <p v-if="addedProductList.length==0" class="text-center justify-center text-neutral-400 text-base font-normal italic font-['Roboto'] leading-6">Add products here by search</p>
                    <div v-else v-for="(product, index) in addedProductList" :key="index" class="w-full py-2 inline-flex flex-col justify-center items-start bg-[#2B2C32]">
                        <div class="w-full px-4 relative inline-flex justify-start items-center gap-4">
                            <img v-if="product.image" class="w-7 h-7 rounded-sm" :src="product.image" />
                            <div v-else class="w-7 h-7 rounded-sm"></div>
                            <div class="w-3.5 h-3.5 relative bg-indigo-300 rounded-sm"></div>

                            <div class="w-44 inline-flex flex-col justify-start items-start gap-0.5">
                                <div class="self-stretch py-2 rounded inline-flex justify-start items-center">
                                    <div class="flex-1 justify-center text-white text-sm font-normal font-['Roboto'] leading-4 line-clamp-1">{{ product.name }}</div>
                                </div>
                            </div>
                            <div class="w-20 inline-flex flex-col justify-start items-start gap-0.5">
                                <div class="self-stretch py-2 rounded inline-flex justify-start items-center">
                                    <div class="flex-1 justify-center text-white text-sm font-normal font-['Roboto'] leading-4 line-clamp-1">{{ product.variantName || 'N/A' }}</div>
                                </div>
                            </div>
                            <div class="w-28 inline-flex flex-col justify-start items-start gap-0.5">
                                <div class="self-stretch py-2 rounded inline-flex justify-start items-center">
                                    <div class="flex-1 justify-center text-white text-sm font-normal font-['Roboto'] leading-4 line-clamp-1">{{ product.category?.name || 'N/A' }}</div>
                                </div>
                            </div>
                            <div class="flex-1 inline-flex flex-col justify-start items-start gap-0.5">
                                <div class="self-stretch py-2 rounded inline-flex justify-start items-center">
                                    <div class="flex-1 justify-center text-white text-sm font-normal font-['Roboto'] leading-4 line-clamp-1">{{ product.brand?.name || 'N/A' }}</div>
                                </div>
                            </div>
                            <div class="w-6 h-6 top-[5px]">
                                <svg @click="removeProduct(product)" class="cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 3V4H4V6H5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V6H20V4H15V3H9ZM7 6H17V19H7V6ZM9 8V17H11V8H9ZM13 8V17H15V8H13Z" fill="#F53333"/>
                                </svg>
                            </div>
                        </div>
                        <div v-for="(lot, ind) in product.lots" :key="index+ind" class="self-stretch pl-24 pr-4 py-1.5 inline-flex justify-start items-center gap-4">
                            <div class="w-[844px] inline-flex flex-col justify-start items-start gap-0.5">
                            <div class="self-stretch py-2 rounded inline-flex justify-start items-center">
                                <div class="flex-1 justify-center text-white text-sm font-normal font-['Roboto'] leading-4 line-clamp-1">Lot {{ lot.batch_lot }}</div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </custom-modal>
</template>
<script>
import { defineComponent, ref } from 'vue'
import {mapGetters,mapMutations} from 'vuex'
import { useSnackbar } from "vue3-snackbar"
import debounce from 'lodash/debounce'
import ProductHelper from '@/helpers/product'
import Helpers from '@/helpers'

import BusinessProductApis from '@/controllers/BusinessProductApis'
import ProductAuditApis from '@/controllers/ProductAuditApis'
import LotSelectPop from './LotSelectPop.vue'


export default defineComponent({
    props: ['payload'],
    components: {
        LotSelectPop
    },
    setup() {
        const snackbar = useSnackbar();
        const search = ref('')
        const open = ref(false)
        const results = ref([])
        const selectedProduct = ref({})
        const lotSelectPopup = ref(false)
        const selectedLots = ref([])
        const addedProductList = ref([])

        return {
            snackbar,
            open,
            search,
            selectedProduct,
            results,
            lotSelectPopup,
            selectedLots,
            addedProductList
        }
    },
    watch: {
        search: debounce(function (val) {
            if(val.length>2){
                this.searchProduct(val)
            }
        }, 600)
    },
    computed: {
        ...mapGetters({
            vg_selectedLocation: 'location/selected'
        }),
  },
    methods: {
        confirmClose(){
            this.confirmNew('Leave?', 'Are you sure you want to leave? Your changes have not been added to the audit list.','Yes', 'bg-white text-theme-red', 'No', 'bg-theme-green text-white', true).then(async () => {
                this.closeClick()
            }).catch(err => {
                console.log(err)
            })
        },
        closeClick(){
            this.$emit('close')
        },
        async searchProduct(search){
            let res = await BusinessProductApis.searchPOV2(search)
            if(res?.data?.payload){
                this.open = true
                const auditDetails = this.payload?.locationInventoryAuditdetails || []
                this.results = res.data.payload.filter(p => {
                    // Product added without batch → omit
                    if (auditDetails.some(d => d.productId === p.id && !d.batchId)) return false

                    // Product with batches → omit only when all batches are already added
                    const batches = p.batchUploadDetails || []
                    if (batches.length > 0) {
                        const allBatchesAdded = batches.every(batch =>
                            auditDetails.some(d => d.productId === p.id && d.batchId === batch.id)
                        )
                        if (allBatchesAdded) return false
                    }

                    return true
                })
            }
        },
        openDropDown(){
            if(this.search){
                this.open = true
            }
        },
        closeDropdown(e){
            if(!e.relatedTarget){
                this.open = false
            }
        },
        resetSearch(){
            this.search = ''
            this.selectedProduct = {}
            this.open = false
        },
        select(product){
            this.selectedProduct = product
            if(product.batchUploadDetails?.length){
                this.lotSelectPopup = true
            }else{
                this.addProduct(product)
            }
        },
        showAddProduct(){
            this.open = false
            this.search = ''
            this.$emit('add')
        },
        addProduct(product, lots){
            if (!product?.id) return
            const item = { ...product, lots: lots && lots.length > 0 ? [...lots] : [] }
            const existingIndex = this.addedProductList.findIndex(p => p.id === product.id)
            if (existingIndex >= 0) {
                this.addedProductList.splice(existingIndex, 1, item)
            } else {
                this.addedProductList.push(item)
            }
            this.open = false
            this.search = ''
            this.lotSelectPopup = false
            this.selectedProduct = {}
            this.selectedLots = []
        },
        removeProduct(product){
            this.addedProductList = this.addedProductList.filter(p => p.id !== product.id)
        },
        async addProducts(){
            let objList = []
            for(let i=0; i<this.addedProductList.length; i++){
                if(this.addedProductList[i]?.lots?.length>0){
                    for(let j=0; j<this.addedProductList[i]?.lots.length; j++){
                        let obj = ProductHelper.getAuditAdd(this.addedProductList[i], this.addedProductList[i]?.lots[j])
                        objList.push(obj)
                    }
                }else{
                    let obj = ProductHelper.getAuditAdd(this.addedProductList[i])
                    objList.push(obj)
                }
            }
            this.vm_spinner(true)
            let res = await ProductAuditApis.addProductToAudit(this.vg_selectedLocation.id, {
                "auditId":this.payload.id,
                "auditProducts":objList,
            })

            this.snackbar.add({
                type: 'info',
                text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
                duration: 3000,
            })
            if(res.status==201){
                this.resetSearch()
                this.$emit('resetSearchClose')
                this.emitter.emit('reloadAddAsnList', true)
            }
            this.vm_spinner(false)
        },
        ...mapMutations({
            vm_spinner: 'spinner/mutateSpinner'
        })
    }
})
</script>
